import styled from "styled-components";

export const Container = styled.h1`
  font-size: 3.6rem;
  font-weight: 600;
  line-height: 4.8rem;
  color: ${({ theme }) => theme.prevColors.grayDark};
`;
